import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          fill="none"
          viewBox="0 0 14 14"
        >
          <path
            fill="#CACADB"
            d="M14 5.174c0-.207-.157-.336-.471-.387l-4.224-.614L7.412.345C7.306.115 7.168 0 7 0c-.168 0-.306.115-.412.345L4.695 4.173.47 4.787c-.314.05-.471.18-.471.387 0 .118.07.253.21.404l3.063 2.979-.724 4.206a1.366 1.366 0 00-.016.168c0 .118.029.218.088.3.059.08.147.121.265.121a.713.713 0 00.336-.1L7 11.265l3.778 1.985a.68.68 0 00.336.101c.23 0 .345-.14.345-.42a1.28 1.28 0 00-.008-.169l-.724-4.206 3.054-2.979c.146-.146.219-.28.219-.404zM9.566 8.178l.606 3.542L7 10.046 3.82 11.72l.614-3.542-2.575-2.499 3.55-.522L7 1.943 8.59 5.157l3.55.522-2.574 2.499z"
          ></path>
        </svg>
    );
}